// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__3096l","validationTips":"StatementDescriptor_validationTips__23Mby"};